
// src/pages/Dashboard.js
import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import Sidebar from '../components/Sidebar/Sidebar';
import FunnelChart from '../components/FunnelChart/FunnelChart';
import ImageryChart from '../components/ImageryChart/ImageryChart';
import './Dashboard.css';
import { useCountry } from '../contexts/CountryContext';
import NPSChart from '../components/NPSChart/NPSChart';
import BrandImageryVisualization from '../components/BrandImageryVisualization/BrandImageryVisualization';
import TrendedChart from '../components/TrendedChart/TrendedChart';
import { useData } from '../contexts/dataContext';
import ReasonToUseVisualization from '../components/ReasonToUseVisualization/ReasonToUseVisualization';
import NPSVisualization from '../components/NPSVisualization/NPSVisualization';
import NPSDriversVisualization from '../components/NPSDriversVisualization/NPSDriversVisualization';

const Dashboard = ({  user, onSignOut,onNavigation }) => {
  const { selectedCountry, updateCountry, countries, setAvailableCountries,globalFilter, setGlobalFilter,projectno } = useCountry();
  const { sampleBrands,logoMap } = useData();
  const [filters, setFilters] = useState({
    brands: [],
    countries: [],
    wave: '',
    demographic: ''
  });
  const [activeTab, setActiveTab] = useState('brandFunnel'); // State to track active tab

  // Sample available brands and countries
  const availableBrands = ['Grab', 'Competitor A', 'Competitor B', 'Competitor C'];
  const availableCountries = ['TH', 'SG', 'MY', 'VN', 'ID', 'PH'];

  const handleFilterChange = (newFilters) => {
    setFilters({...filters, ...newFilters});
  };

  // Function to render the appropriate component based on active tab
  const renderActiveComponent = () => {
    switch(activeTab) {
      case 'brandFunnel':
        return (
          <div className="chart-section">
            <h3>Brand Funnel</h3>
            <FunnelChart filters={filters} selectedCountry={selectedCountry} />
          </div>
        );
      case 'imagery':
        return (
          <div className="chart-section">
            <h3>Imagery</h3>
            {/* <ImageryChart filters={filters} selectedCountry={selectedCountry} /> */}
            <BrandImageryVisualization data={sampleBrands} logoMap={logoMap}  page={activeTab}/>
            
          </div>
        );
        case 'affordable':
        return (
          <div className="chart-section">
            <h3>Brand NPS</h3>
            <BrandImageryVisualization data={sampleBrands} logoMap={logoMap} page={activeTab}/>
          </div>
        );
        case 'nps':
        return (
          <div className="chart-section">
            <h3>Brand NPS</h3>
            <NPSVisualization data={sampleBrands} logoMap={logoMap} page={activeTab}/>
          </div>
        );
    case 'driversnps':
        return (
          <div className="chart-section">
            <h3>NPS Drivers</h3>
            <NPSDriversVisualization data={sampleBrands} logoMap={logoMap} page={activeTab}/>
          </div>
        );

        
        case 'reasonToUse':
        return (
          <div className="chart-section">
            <h3>Reason to Use</h3>
            <ReasonToUseVisualization data={sampleBrands}  logoMap={logoMap} />
          </div>
        );
         case 'barrierToUse':
        return (
          <div className="chart-section">
            <h3>Barrier to Use</h3>
            <ReasonToUseVisualization data={sampleBrands}  logoMap={logoMap} />
          </div>
        );
        case 'trended':
        return (
    <div className="chart-section">
            <h3>Bar TrendedChart</h3>
            <TrendedChart filters={filters}  selectedCountry={sampleBrands} />
          </div>
        );
        
      default:
        return (
          <div className="chart-section">
            <h3>Brand Funnel</h3>
            <FunnelChart filters={filters} selectedCountry={selectedCountry} />
          </div>
        );
    }
  };

  return (
  <div className="dashboard-container">
    <Navbar user={user} onSignOut={onSignOut} onNavigation={onNavigation} />
    
    <div className="dashboard-content">
      <Sidebar 
        filters={filters} 
        onFilterChange={handleFilterChange}
        availableBrands={availableBrands}
        availableCountries={availableCountries}
        projectno={projectno}
      />
      
      <div className="dashboard-main">
        {/* Tab Navigation Menu - Now with sticky positioning */}
        <div className="tab-navigation-sticky-wrapper">
          <div className="tab-navigation">
            <button 
              className={`tab-button ${activeTab === 'brandFunnel' ? 'active' : ''}`}
              onClick={() => {
                setActiveTab('brandFunnel');
                setGlobalFilter('Brand Funnel');
              }}
            >
              Brand Funnel
            </button>
            {projectno!='2' && <button 
              className={`tab-button ${activeTab === 'imagery' ? 'active' : ''}`}
              onClick={() => {
                setActiveTab('imagery');
                setGlobalFilter('Brand Imagery');
              }}
            >
              Imagery
            </button>}
            {/* <button 
              className={`tab-button ${activeTab === 'affordable' ? 'active' : ''}`}
              onClick={() => {
                setActiveTab('affordable');
                setGlobalFilter('Provides me with affordable');
              }}
            >
              Affordable Option
            </button> */}
            <button 
              className={`tab-button ${activeTab === 'reasonToUse' ? 'active' : ''}`}
              onClick={() => {
                setActiveTab('reasonToUse');
                setGlobalFilter('Reason to use');
              }}
            >
              Reason to Use
            </button>
            <button 
              className={`tab-button ${activeTab === 'barrierToUse' ? 'active' : ''}`}
              onClick={() => {
                setActiveTab('barrierToUse');
                setGlobalFilter('Barriers to use');
              }}
            >
              Barrier to Use
            </button>
            <button 
              className={`tab-button ${activeTab === 'nps' ? 'active' : ''}`}
              onClick={() => {
                setActiveTab('nps');
                setGlobalFilter('NPS Food Delivery');
              }}
            >
              NPS
            </button>
            {/* <button 
              className={`tab-button ${activeTab === 'driversnps' ? 'active' : ''}`}
              onClick={() => {
                setActiveTab('driversnps');
                setGlobalFilter('NPS level 1');
              }}
            >
              NPS Drivers
            </button> */}
          </div>
        </div>
        
        {/* Render active component based on tab selection */}
        {renderActiveComponent()}
      </div>
      
    </div>
  </div>
);
};
export default Dashboard;